import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { HiArrowRight } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { BackgroundBeamsWithCollision } from "../components/animations/background-beams-with-collision";
import { HoverBorderGradient } from "../components/animations/hover-border-gradient";
import { FeatureIconContainer } from "../components/features/feature-icon-container";
import { IconReceiptFilled } from "@tabler/icons-react";
import { Heading } from "../components/ui/heading";
import { Subheading } from "../components/ui/subheading";
import { Timeline } from "./TimeLine";
import HowItWorts from "./HowItWorts";
import WhyJoin from "./WhyJoin";

const AffiliatePage = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);
  return (
    <>
      <BackgroundBeamsWithCollision>
        <div className="relative w-full">
          <svg
            className="absolute inset-x-0 bottom-0 text-neutral-900"
            viewBox="0 0 1160 163"
          >
            <path
              fill="currentColor"
              d="M-164 13L-104 39.7C-44 66 76 120 196 141C316 162 436 152 556 119.7C676 88 796 34 916 13C1036 -8 1156 2 1216 7.7L1276 13V162.5H1216C1156 162.5 1036 162.5 916 162.5C796 162.5 676 162.5 556 162.5C436 162.5 316 162.5 196 162.5C76 162.5 -44 162.5 -104 162.5H-164V13Z"
            />
          </svg>
          <div className="relative px-4 py-16 mx-auto overflow-hidden sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
            <div className="flex flex-col items-center justify-between xl:flex-row">
              <div
                className="w-full max-w-xl mb-12 xl:mb-0 xl:pr-16 xl:w-7/12"
                data-aos="fade-up-right"
              >
                <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-white sm:text-5xl sm:leading-none">
                  Join the{" "}
                  <span className="bg-clip-text text-transparent bg-no-repeat bg-gradient-to-r from-fuchsia-700 via-fuchsia-600 to-pink-600">
                    WhizManage
                  </span>{" "}
                  <br className="hidden md:block" />
                  Affiliate Program today
                </h2>
                <p className="max-w-xl mb-4 text-base text-gray-200 md:text-lg">
                  Become a WhizManage Affiliate, promote our plugin, and earn a
                  30% commission on your affiliate sales.
                </p>
                <div className="flex items-center gap-4 justify-start my-10 relative z-10 dark">
                  <Link
                    activeClass="active"
                    spy={true}
                    to="/affiliate-home/affiliate-register/"
                    smooth="easeInOutQuint"
                    duration={1000}
                    delay={200}
                    offset={20}
                  >
                    <HoverBorderGradient
                      containerClassName="rounded-full"
                      as="button"
                      className="dark:bg-black bg-white text-black dark:text-white flex items-center space-x-2 group"
                    >
                      <span>Become an Affiliate</span>
                      <HiArrowRight className="text-white group-hover:translate-x-1 stroke-[1px] h-3 w-3 mt-0.5 transition-transform duration-200" />
                    </HoverBorderGradient>
                  </Link>
                  <Link
                    activeClass="active"
                    reloadDocument
                    spy={true}
                    to="/my-account/my-affiliates/"
                    smooth="easeInOutQuint"
                    duration={1000}
                    delay={200}
                    offset={20}
                  >
                    <HoverBorderGradient
                      containerClassName="rounded-full"
                      as="button"
                      className="dark:bg-black bg-white text-black dark:text-white flex items-center space-x-2 group"
                    >
                      <span>Already an Affiliate</span>
                      <HiArrowRight className="text-white group-hover:translate-x-1 stroke-[1px] h-3 w-3 mt-0.5 transition-transform duration-200" />
                    </HoverBorderGradient>
                  </Link>
                </div>
              </div>
              <div
                className="w-full max-w-xl xl:w-6/12"
                data-aos="fade-up-left"
              >
                <img
                  src={
                    window.siteUrl +
                    "/wp-content/plugins/innovative-design/public/images/affiliate-png-remove-bg.png"
                  }
                  className="object-cover w-full h-full !rounded-2xl"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </BackgroundBeamsWithCollision>
      <div className="min-h-screen bg-neutral-900 -mt-0.5 z-10">
        <HowItWorts />
        <WhyJoin />
      </div>
    </>
  );
};

export default AffiliatePage;
